"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAvailableForApplication = exports.isAvailableForCustomer = exports.isAvailableForCustomerGroup = exports.canAddProductToCart = exports.hasItemNotes = exports.hasCartNote = exports.isItemBundle = exports.hasItems = exports.hasCoupon = exports.isNoteLabeled = exports.isNoteSimple = exports.detectNoteType = exports.hasBillingAddress = exports.hasShippingAddress = exports.hasRequestedDelivery = exports.isCreatedByGuest = exports.hasCustomer = void 0;
var product_helpers_1 = require("../catalog/product-helpers");
var hasCustomer = function (cart) { return !!cart.customer; };
exports.hasCustomer = hasCustomer;
var isCreatedByGuest = function (cart) { return 'guest_id' in cart.customer; };
exports.isCreatedByGuest = isCreatedByGuest;
var hasRequestedDelivery = function (cart) { return !!cart.requested_delivery; };
exports.hasRequestedDelivery = hasRequestedDelivery;
var hasShippingAddress = function (cart) {
    return !!cart.shipping_address_id || !!cart.shipping_address;
};
exports.hasShippingAddress = hasShippingAddress;
var hasBillingAddress = function (cart) {
    return !!(cart.billing_address_id || cart.billing_address);
};
exports.hasBillingAddress = hasBillingAddress;
var detectNoteType = function (note) {
    return !note || Array.isArray(note) ? 'simple' : 'labeled';
};
exports.detectNoteType = detectNoteType;
var isNoteSimple = function (note) {
    return (0, exports.detectNoteType)(note) === 'simple';
};
exports.isNoteSimple = isNoteSimple;
var isNoteLabeled = function (note) {
    return (0, exports.detectNoteType)(note) === 'labeled';
};
exports.isNoteLabeled = isNoteLabeled;
var hasCoupon = function (cart) { return !!cart.applied_coupon; };
exports.hasCoupon = hasCoupon;
var hasItems = function (cart) { return cart.items.length > 0; };
exports.hasItems = hasItems;
var isItemBundle = function (item) { return 'components' in item; };
exports.isItemBundle = isItemBundle;
var hasCartNote = function (cart) { return !!cart.note; };
exports.hasCartNote = hasCartNote;
var hasItemNotes = function (item) {
    if (Array.isArray(item.notes) && item.notes.length) {
        return true;
    }
    return typeof item.notes === 'object' && Object.keys(item.notes).length > 0;
};
exports.hasItemNotes = hasItemNotes;
var canAddProductToCart = function (product, quantity, application, customerId, customerGroups) {
    if (quantity === void 0) { quantity = 1; }
    if (!(0, exports.isAvailableForApplication)(product, application)) {
        return false;
    }
    if (!(0, exports.isAvailableForCustomer)(product, customerId)) {
        return false;
    }
    if (!(0, product_helpers_1.isAvailable)(product)) {
        return false;
    }
    if (customerGroups && !(0, exports.isAvailableForCustomerGroup)(product, customerGroups)) {
        return false;
    }
    if ((0, product_helpers_1.isBundle)(product)) {
        return true;
    }
    if ((0, product_helpers_1.isBundleExclusive)(product)) {
        return false;
    }
    return !(0, product_helpers_1.isSoldOut)(product, quantity);
};
exports.canAddProductToCart = canAddProductToCart;
var isAvailableForCustomerGroup = function (product, groups) {
    var _a;
    if (!((_a = product.customer_group) === null || _a === void 0 ? void 0 : _a.length)) {
        return true;
    }
    return product.customer_group.some(function (g) { return groups.includes(g); });
};
exports.isAvailableForCustomerGroup = isAvailableForCustomerGroup;
var isAvailableForCustomer = function (product, customerId) {
    if (!(product.customer_ids || []).length) {
        return true;
    }
    return (product.customer_ids || []).includes(customerId !== null && customerId !== void 0 ? customerId : '');
};
exports.isAvailableForCustomer = isAvailableForCustomer;
var isAvailableForApplication = function (product, application) {
    if (!(product.application || []).length) {
        return true;
    }
    return (product.application || []).includes(application);
};
exports.isAvailableForApplication = isAvailableForApplication;
//# sourceMappingURL=cart-helpers.js.map